var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn waves-effect waves-light btn-brico",on:{"click":_vm.add}},[_vm._v("Ajouter au panier"),_c('i',{staticClass:"material-icons right"},[_vm._v("add_shopping_cart")])])}
var staticRenderFns = []

export { render, staticRenderFns }